export type PrizmIconsName = string;

export interface PrizmIcon {
  name: string;
  data: string;
}
